@if (disabled) {
  <p-button
    [type]="type"
    [label]="label"
    [icon]="icon"
    [iconPos]="iconPos"
    [loading]="loading"
    [loadingIcon]="loadingIcon"
    [disabled]="true"
    [style]="styleSheet"
    [styleClass]="styleClass"
    (onClick)="onClick.emit($event)"
    (onBlur)="onBlur.emit($event)"
    (onFocus)="onFocus.emit($event)">
    @if (contentTemplate) {
      <ng-template pTemplate="content">
        <ng-template [ngTemplateOutlet]="contentTemplate"></ng-template>
      </ng-template>
    }
  </p-button>
} @else {
  <p-button
    [type]="type"
    [label]="label"
    [icon]="icon"
    [iconPos]="iconPos"
    [loading]="loading"
    [loadingIcon]="loadingIcon"
    [style]="styleSheet"
    [styleClass]="styleClass"
    (onClick)="onClick.emit($event)"
    (onBlur)="onBlur.emit($event)"
    (onFocus)="onFocus.emit($event)">
    @if (contentTemplate) {
      <ng-template pTemplate="content">
        <ng-template [ngTemplateOutlet]="contentTemplate"></ng-template>
      </ng-template>
    }
  </p-button>
}
